module.exports = __webpack_public_path__ + "static/media/Background.458ff9ec.png";